<template>
  <div class="money-page">
    <h3 class="page-title">{{ $t("deposit.deposit_form") }}</h3>

    <section class="balance-card">
      <span class="muted">{{ $t("deposit.user_balance") }}</span>
      <div class="balance-value">
        <b>{{ Number($store.state.amount).toLocaleString() }}</b>
        <span>Unit</span>
      </div>
    </section>

    <section class="form-card">
      <label>{{ $t("deposit.choose_payment_type") }}</label>
      <AccountSelect
        :data="selected_account"
        field="account_id"
        :accounts="accounts"
      />
      <span class="error">{{ errors.account }}</span>

      <div class="account-box" v-if="account.length !== 0">
        <h4>{{ account[0].name }}</h4>
        <div class="qr-wrap" v-if="selectedAccountQrImage">
          <img
            :src="selectedAccountQrImage"
            alt="Payment QR"
            class="qr-image"
          />
        </div>
        <div class="info-row">
          <span>{{ $t("deposit.account_name") }}</span>
          <b>{{ account[0].account_name }}</b>
        </div>
        <div class="info-row">
          <span>{{ $t("deposit.account_number") }}</span>
          <div class="copy-wrap">
            <b id="textToCopy">{{ account[0].number }}</b>
            <button type="button" class="copy-btn" @click="copyText">
              Copy
            </button>
          </div>
        </div>
        <p class="remark">{{ $t("deposit.account_remark") }}</p>
      </div>
    </section>

    <section class="form-card">
      <label>{{ $t("deposit.screenshot") }}</label>
      <div class="uploader-wrap">
        <van-uploader v-model="imageUploader" :max-count="1" />
      </div>
      <span class="error">{{ errors.image }}</span>

      <label>{{ $t("deposit.amount") }}</label>
      <small>{{ $t("deposit.minimum_deposit") }}</small>
      <input
        type="number"
        class="form-control"
        v-model="depositData.amount"
      />
      <span class="error">{{ errors.amount }}</span>

      <button type="button" class="submit-btn" @click="onSubmit">
        <span v-if="!isConfirm">{{ $t("deposit.submit") }}</span>
        <Loading color="#1a1408" v-if="isConfirm" size="22" />
      </button>
    </section>
  </div>
</template>
<script>
import { Toast, Loading } from "vant";
import { mapActions } from "vuex";
import AccountSelect from "./components/AccountSelect.vue";

export default {
  components: { AccountSelect, Loading },
  data() {
    return {
      selected_account: {},
      accounts: [],
      account: [],
      imageUploader: [],
      depositData: {},
      errors: {},
      isConfirm: false,
    };
  },
  methods: {
    ...mapActions(["fetchUser"]),
    onSubmit() {
      this.$playSound();
      this.sendDepositData();
    },
    copyText() {
      const textToCopy = document.getElementById("textToCopy").innerText;
      const textarea = document.createElement("textarea");
      textarea.value = textToCopy;
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand("copy");
      document.body.removeChild(textarea);
      Toast.success(
        this.$store.state.language === "en" ? "Copied!" : "ကူးပြီးပါပြီ"
      );
    },
    async fetchAccounts() {
      try {
        const res = await axios.get("/accounts", {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        });
        this.accounts = res.data.data;
      } catch (error) {
        console.log(error);
      }
    },
    async sendDepositData() {
      try {
        await this.fetchUser();
        this.errors = {};
        if (!this.selected_account.account_id) {
          this.errors.account = this.$t("deposit.enter_account_type");
          return false;
        }
        if (!this.imageUploader.length > 0) {
          this.errors.image = this.$t("deposit.enter_screenshot_photo");
          return false;
        }
        if (!this.depositData.amount) {
          this.errors.amount = this.$t("deposit.enter_amount");
          return false;
        }
        if (this.depositData.amount < 3000) {
          this.errors.amount = this.$t("deposit.enter_at_least");
          return false;
        }
        this.isConfirm = true;
        if (this.imageUploader[0]) {
          this.depositData.transaction_image = this.imageUploader[0].content;
        }
        this.depositData.account_id = this.account[0].id;
        this.depositData.date = this.currentTime;
        await axios.post("/deposits", this.depositData, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        });
        this.imageUploader = [];
        this.depositData = {};
        this.selected_account.account_id = null;
        Toast.success(
          this.$store.state.language === "en" ? "Success" : "အောင်မြင်သည်။"
        );
        this.isConfirm = false;
      } catch (error) {
        Toast.fail(
          this.$store.state.language === "en" ? "Fail" : "ကျရှုံးသည်။"
        );
        this.isConfirm = false;
      }
      return true;
    },
    createDateWithTimeZone() {
      const moment = require("moment-timezone");
      const dateInTimeZone = moment.tz(new Date(), "Asia/Rangoon");
      const year = dateInTimeZone.year();
      const month = dateInTimeZone.month();
      const day = dateInTimeZone.date();
      const hour = dateInTimeZone.hour();
      const minute = dateInTimeZone.minute();
      const second = dateInTimeZone.second();
      const millisecond = dateInTimeZone.millisecond();
      return new Date(year, month, day, hour, minute, second, millisecond);
    },
  },
  watch: {
    "selected_account.account_id": function () {
      this.account = this.accounts.filter(
        (account) =>
          String(account.id) === String(this.selected_account.account_id)
      );
    },
  },
  computed: {
    currentTime() {
      return moment(this.createDateWithTimeZone()).format("lll");
    },
    selectedAccountQrImage() {
      if (!this.account.length) return "";
      return this.account[0].qr_image || "";
    },
  },
  async mounted() {
    this.fetchAccounts();
    const authUser = await this.fetchUser();
    if (!authUser) {
      this.$router.push("/auth/login");
    }
  },
};
</script>
<style scoped>
.money-page {
  min-height: 100vh;
  padding: 14px 14px 8rem;
}

.page-title {
  margin-bottom: 12px;
  color: #f0e6c8;
  font-weight: 700;
}

.balance-card,
.form-card,
.account-box {
  background: #1c1c1c;
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 14px;
}

.balance-card {
  padding: 14px;
  margin-bottom: 12px;
}

.muted {
  display: block;
  font-size: 0.75rem;
  color: #b8b3a8;
}

.balance-value {
  display: flex;
  align-items: baseline;
  gap: 6px;
  color: #f7d56a;
}

.balance-value b {
  font-size: 1.4rem;
}

.form-card {
  padding: 14px;
  margin-bottom: 12px;
}

.form-card label {
  display: block;
  margin-bottom: 6px;
  color: #f0e6c8;
  font-weight: 600;
}

.form-card small {
  display: block;
  margin-bottom: 6px;
  color: #d8c48a;
}

.account-box {
  margin-top: 12px;
  padding: 12px;
}

.account-box h4 {
  margin-bottom: 8px;
  color: #f0e6c8;
}

.qr-wrap {
  display: flex;
  justify-content: center;
  margin: 10px 0 12px;
  padding: 12px;
  border-radius: 12px;
  background: #fff;
}

.qr-image {
  width: min(100%, 240px);
  height: auto;
  display: block;
  border-radius: 8px;
}

.info-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
  padding: 8px 0;
  border-top: 1px solid rgba(255, 255, 255, 0.06);
}

.copy-wrap {
  display: flex;
  align-items: center;
  gap: 8px;
}

.copy-btn {
  border: 0;
  border-radius: 999px;
  padding: 4px 10px;
  background: linear-gradient(180deg, #f7d56a, #e7b534);
  color: #1a1408;
  font-size: 0.75rem;
  font-weight: 700;
}

.remark {
  margin: 8px 0 0;
  font-size: 0.78rem;
  color: #c9c3b8;
}

.uploader-wrap {
  display: flex;
  justify-content: center;
  margin-bottom: 12px;
}

.error {
  display: block;
  min-height: 1em;
  margin-bottom: 8px;
  color: #ff7a59;
  font-size: 0.78rem;
}

.submit-btn {
  width: 100%;
  margin-top: 8px;
  padding: 11px;
  border: 0;
  border-radius: 12px;
  background: linear-gradient(180deg, #f7d56a, #e7b534);
  color: #1a1408;
  font-weight: 700;
}

.form-control {
  margin-bottom: 4px;
}
</style>
